import React from "react"
import { Button } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { StatusBadge } from "../../common/badge"
import { DeleteButtonWithConfirmation } from "../../common/button"
import { FormattedInputWithActions } from "../../common/inputs"
import { BasicRow } from "../../common/listing/ListingTypes"
import ListingWrapper from "../../common/listing/ListingWrapper"
import IntlProps from "../../state/helpers/IntlProps"
import { ProductAction } from "../../state/product/actions"
import { ProductSelector } from "../../state/product/selectors"
import { PRODUCT_SUPPLIER_COST_LISTING_MESSAGES } from "../../utils/product"

export const ProductSupplierCostListing = injectIntl((props: IntlProps) => {
    const supplierCosts = useSelector(ProductSelector.getSupplierCosts)
    const dispatch = useDispatch()


    const headers = [
        props.intl.formatMessage(PRODUCT_SUPPLIER_COST_LISTING_MESSAGES.header_supplier),
        props.intl.formatMessage(PRODUCT_SUPPLIER_COST_LISTING_MESSAGES.header_cost),
        "",
    ]

    const setDefault = (id: string) => {
        dispatch(ProductAction.patch({
            supplierCost: {
                id: id,
                isDefault: true
            }
        }))
    }

    const setDeleted = (id: string) => {
        dispatch(ProductAction.patch({
            supplierCost: {
                id: id,
                deleted: true
            }
        }))
    }

    const setCost = (id: string, cost: string) => {
        dispatch(ProductAction.patch({
            supplierCost: {
                id: id,
                cost: cost,
            }
        }))
    }

    const rows: Array<BasicRow> = supplierCosts.map(supplierCost => {
        const isDefault = supplierCost.attributes.isDefault
        return {
            rowId: supplierCost.id,
            data: [
                <>
                    <Link className="pr-2" to={`/suppliers/${supplierCost.attributes.supplierId}/details`}>
                        {supplierCost.attributes.supplierName}
                    </Link>
                    <StatusBadge
                        text={isDefault ? props.intl.formatMessage(PRODUCT_SUPPLIER_COST_LISTING_MESSAGES.default_supplier_cost_badge_label) : ""}
                        colorCode={"#17cdc1"}
                    />
                </>,
                <span key={`input_${supplierCost.id}_${supplierCost.attributes.cost}`}>
                    <FormattedInputWithActions
                        onSaveCallback={v => setCost(supplierCost.id, v)}
                        value={supplierCost.attributes.cost}
                    />
                </span>,
                <span key={supplierCost.id} className={"float-right"}>
                    {!isDefault &&
                        <Button variant={"outline-primary"} size={"sm"} className="mr-2"
                            onClick={() => setDefault(supplierCost.id)}>
                            {props.intl.formatMessage(PRODUCT_SUPPLIER_COST_LISTING_MESSAGES.use_as_default_button_label)}
                        </Button>
                    }

                    <DeleteButtonWithConfirmation onClickCallback={() => setDeleted(supplierCost.id)}/>
                </span>
            ],
        }
    })


    return (
        <>
            <ListingWrapper
                isLoading={false}
                search={<></>}
                showHeaders={true}
                standardListProps={{
                    className: "row pt-3 pb-0",
                    headers: {data: headers, classNames: ["", "", ""]},
                    rows: rows,
                    smallLine: true,
                    pageSize: 0,
                    totalItemsCount: 0,
                    showSelectionSize: false,
                }}
                footer={rows.length > 0 ? <div className="pb-3"></div> :
                    <div className="row ui-has-modules pt-0 pb-0">
                        <div className="col-12 ui-module text-center">
                            <small className="col-12">
                                {props.intl.formatMessage(PRODUCT_SUPPLIER_COST_LISTING_MESSAGES.empty_listing_message)}
                            </small>
                        </div>
                    </div>
                }
            />
        </>
    )
})


// WEBPACK FOOTER //
// ./src/product/components/ProductSupplierCostListing.tsx